<script setup>
import defineProps from "vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";

defineProps({
  title: {
    type: String,
    required: true
  },
  content: {
    type: String,
    required: true
  },
  link: {
    type: String,
    required: true
  },
  phone: {
    type: String,
    required: false,
    default: ''
  }
})
</script>

<template>
  <div class="secondary-item d-flex">
    <div class="content">
      <div class="title">{{ title }}</div>
      <div class="description">{{ content }}</div>
    </div>
    <div class="buttons">
      <div class="mb-2">
        <a :href="link" target="_blank">
          <MainButton class="read-more w-100">{{ $t('go-to-website') }}</MainButton>
        </a>
      </div>
      <div v-if="phone">
        <a :href="`tel://${phone}`">
          <MainButton class="read-more w-100" outline="true">{{ $t('call') }}</MainButton>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.secondary-item {
  background-color: $color-pink-light;
  color: $color-purple;
  position: relative;
  padding: 20px;
  border-radius: 10px;
  font-size: 14px;

  .title {
    font-family: $font-semi-bold;
    margin-bottom: 8px;
  }

  .description {
    white-space: pre-line;
  }

  .buttons {
    margin-left: auto;
  }
}
</style>
